module.exports = __webpack_public_path__ + "4a4d3e253d905d8dec14ed782df93cda.svg";